import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ScrollService } from '../scroll.service';

@Injectable()
export class ScrollInterceptor implements HttpInterceptor {

  constructor(private scrollService: ScrollService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          if (!(req.url.includes('Documents/upload') || req.url.includes('Common/GetCommercialRegistery') || req.url.includes('ServiceCatalog/upload')) ) {
            this.scrollService.scrollToTop();
          }
        }
      })
    );
  }
}
